// tslint:disable
export enum CaseExternalIdType {
    /**
     * @description ASSISTRX CASE ID
     */
    ARXCID = 1,
    /**
     * @description Nursing Platform ID
     */
    NPID = 2,
    /**
     * @description Transitional Id
     */
    TRANID = 3,
    /**
     * @description Member Number
     */
    MemberNumber = 4,
    /**
     * @description Migration
     */
    Mig = 5,
    /**
     * @description Medical Member ID
     */
    MedMemberID = 6,
    /**
     * @description Pharmacy Member ID
     */
    PharMemberID = 7,
    /**
     * @description Case Mask ID
     */
    CaseMaskID = 8,
    /**
     * @description Trialcard Claim ID
     */
    TCClaimID = 9,
    /**
     * @description Disposition Code
     */
    DispositionCode = 10,
    /**
     * @description AssistRx Rx ID
     */
    ARXRxId = 11,
    /**
     * @description Staging Virmedica Data Feed ID
     */
    StgVirmedicaDFID = 12,
    /**
     * @description Trialcard EOB ID
     */
    TCEobID = 13,
    /**
     * @description Third Party ID
     */
    ThirdPartyId = 14,
    /**
     * @description CarePath ID
     */
    CarePathId = 15,
    /**
     * @description Virmedica Response ID
     */
    VRMResponseId = 16,
    /**
     * @description Virmedica Transaction ID
     */
    VRMTransactionId = 17,
    /**
     * @description Virmedica Benefits Verification Id
     */
    VRMBVId = 18,
    /**
     * @description Virmedica Patient Id
     */
    VRMPatientId = 19,
    /**
     * @description Site Account ID
     */
    SiteAccountId = 20,
    /**
     * @description Outbound Staging Virmedica Data Feed ID
     */
    OtbnStgVirmedicaDFID = 21,
    /**
     * @description Third Party Case/Enrollment ID provided by an External Client
     */
    ThirdPartyCaseId = 22,
    /**
     * @description McKesson Case Id
     */
    CaseMckId = 23,
    /**
     * @description Prescription ID
     */
    ERxID = 24,
    /**
     * @description REMS ID
     */
    RemsId = 25,
    /**
     * @description Mango Activation Id
     */
    MangoActivationId = 26,
    /**
     * @description Enrollment Feed Id
     */
    EnrollFeedId = 27,
    /**
     * @description Sunovion ID
     */
    SunovionID = 28,
    /**
     * @description PharmaCord Patient ID
     */
    PharmaCordPatientId = 29,
    /**
     * @description IBond ID
     */
    IBondId = 30,
    /**
     * @description IBond Enrollment ID
     */
    IBondEnrollmentId = 31,
    /**
     * @description Infinitus ID
     */
    InfinitusId = 32,
    /**
     * @description EvinceMed ID
     */
    EvinceMedId = 33,
    /**
     * @description Subject ID
     */
    SubjectId = 34,
    /**
     * @description CMM PA Key
     */
    CMMPAKey = 35,
}
(CaseExternalIdType as any)['MEMBERNUMBER'] = 4;
(CaseExternalIdType as any)['MIG'] = 5;
(CaseExternalIdType as any)['MEDMEMBERID'] = 6;
(CaseExternalIdType as any)['PHARMEMBERID'] = 7;
(CaseExternalIdType as any)['CASEMASKID'] = 8;
(CaseExternalIdType as any)['TCCLAIMID'] = 9;
(CaseExternalIdType as any)['DISPOSITIONCODE'] = 10;
(CaseExternalIdType as any)['ARXRXID'] = 11;
(CaseExternalIdType as any)['STGVIRMEDICADFID'] = 12;
(CaseExternalIdType as any)['TCEOBID'] = 13;
(CaseExternalIdType as any)['THIRDPARTYID'] = 14;
(CaseExternalIdType as any)['CAREPATHID'] = 15;
(CaseExternalIdType as any)['VRMRESPONSEID'] = 16;
(CaseExternalIdType as any)['VRMTRANSACTIONID'] = 17;
(CaseExternalIdType as any)['VRMBVID'] = 18;
(CaseExternalIdType as any)['VRMPATIENTID'] = 19;
(CaseExternalIdType as any)['SITEACCOUNTID'] = 20;
(CaseExternalIdType as any)['OTBNSTGVIRMEDICADFID'] = 21;
(CaseExternalIdType as any)['THIRDPARTYCASEID'] = 22;
(CaseExternalIdType as any)['CASEMCKID'] = 23;
(CaseExternalIdType as any)['ERXID'] = 24;
(CaseExternalIdType as any)['REMSID'] = 25;
(CaseExternalIdType as any)['MANGOACTIVATIONID'] = 26;
(CaseExternalIdType as any)['ENROLLFEEDID'] = 27;
(CaseExternalIdType as any)['SUNOVIONID'] = 28;
(CaseExternalIdType as any)['PHARMACORDPATIENTID'] = 29;
(CaseExternalIdType as any)['IBONDID'] = 30;
(CaseExternalIdType as any)['IBONDENROLLMENTID'] = 31;
(CaseExternalIdType as any)['INFINITUSID'] = 32;
(CaseExternalIdType as any)['EVINCEMEDID'] = 33;
(CaseExternalIdType as any)['SUBJECTID'] = 34;
(CaseExternalIdType as any)['CMMPAKEY'] = 35;
